/****************************************************************************************************
* hoco -> page-home > contact
****************************************************************************************************/
// import { appData } from "./config";


////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// let hocoIsSnippet = true;
// if(hocoIsSnippet && typeof hocoIsRevert !== 'undefined') hocoScrollClear();



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Variables & Functions
let hocoSel = '.sector.contact ';



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Scroll & Animation
let hocoScrubTl1; // eslint-disable-line no-unused-vars
let hocoElGrTl;  // eslint-disable-line no-unused-vars
let hocoElBlobTl;  // eslint-disable-line no-unused-vars
let hocoShowTl; // eslint-disable-line no-unused-vars
let hocoContactLen1 = 4963;
let hocoContactLen2 = 4513;


////////////////////////////////////////////////// Init
const hocoInit = (gsapRef, splitTextRef) => {  
  // gsapRef.set(`${hocoSel} .container-in`, {y: '-120%'});
  gsapRef.set(`${hocoSel} .container-in`, {y: '-100%'});

  gsapRef.set(`${hocoSel} .contents-wrapper`, {pointerEvents: 'none'});
  gsapRef.set(`${hocoSel} .contact-infos`, {pointerEvents: 'none'});

  gsapRef.set(`${hocoSel} .contents-bg`, {opacity:0});

  gsapRef.set('#ho-co-gr3', {attr: {gradientTransform: "rotate(0, 0.5, 0.5)"}});

  gsapRef.set(`${hocoSel} .blob-g1`, {transformOrigin: '50% 50%', opacity: 0});
  for(let i = 1; i <= 5; i++) gsapRef.set(`${hocoSel} #blob0${i}-a`, {morphSVG: `${hocoSel} #blob0${i}-a`});
  gsapRef.set(`${hocoSel} .blob01-g`, {x: '-70%', y: '-20%', rotate: 10, scale: 0.5});
  gsapRef.set(`${hocoSel} .blob02-g`, {x: '50%', y: '-50%', rotate: 60, scale: 0.5});
  gsapRef.set(`${hocoSel} .blob03-g`, {x: '50%', y: '50%', rotate: 30, scale: 0.5});
  gsapRef.set(`${hocoSel} .blob04-g`, {x: '0%', y: '50%', rotate: 30, scale: 0.5});
  gsapRef.set(`${hocoSel} .blob05-g`, {x: '-50%', y: '50%', rotate: 60, scale: 0.5});

  gsapRef.set(`${hocoSel} .blob-g2`, {transformOrigin: '50% 50%', opacity: 0});
  for(let i = 6; i <= 10; i++) gsapRef.set(`${hocoSel} .blob${(i<10)?'0':''}${i}.blob-a`, {morphSVG: `${hocoSel} .blob${(i<10)?'0':''}${i}.blob-a`});
  gsapRef.set(`${hocoSel} .blob06-g`, {x: '-100%', y: '50%', rotate: 0, scale: 0});
  gsapRef.set(`${hocoSel} .blob07-g`, {x: '100%', y: '-100%', rotate: 0, scale: 0});
  gsapRef.set(`${hocoSel} .blob08-g`, {x: '0%', y: '0%', rotate: 0, scale: 0.2});
  gsapRef.set(`${hocoSel} .blob09-g`, {x: '-100%', y: '-100%', rotate: 0, scale: 0});
  gsapRef.set(`${hocoSel} .blob10-g`, {x: '100%', y: '50%', rotate: 0, scale: 0});

  gsapRef.set(`${hocoSel} .drops`, {'--hoco-drop-play-state': 'paused', opacity: 0});

  gsapRef.set(hocoSel+'.components-behind', {opacity: 0});

  gsapRef.set(hocoSel+'.contact.no1 .use1', {opacity: 0});
  gsapRef.set(hocoSel+'.contact.no1 .use2', {opacity: 1, strokeDasharray: hocoContactLen1, strokeDashoffset: hocoContactLen1});
  gsapRef.set(hocoSel+'.contact:not(.no1)', {opacity: 0, y: '0%'});

  gsapRef.set(hocoSel+'.contact-info', {opacity: 0, y: '-50%', rotateX: 30}); 
}


////////////////////////////////////////////////// Scroll
const hocoScrollMake = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {

  ////////////////////////////// Scroll1: Pin contact over retouch slide  
  hocoScrubTl1 = gsapRef.timeline({
    scrollTrigger: {
      id: 'hocoScrubTl1',
      trigger: hocoSel,   
      toggleActions: 'restart complete reverse reset',
      // start: 'top 120%',
      start: 'top 100%',
      end: 'top top',
      scrub: true,
      toggleClass: 'active',
      // markers: {startColor: "black", endColor: "black", fontSize: "10px", fontWeight: "bold", indent: 0},
    }
  })
  .to(`${hocoSel} .container-in`, {duration: 1, y: '0%', ease: 'none'})
  .add(() => {}, 1)
  ;


  ////////////////////////////// Elements Animation: Gradient BG
  hocoElGrTl = gsapRef.timeline({paused: true})
    .to('#ho-co-gr3', {duration: 10, attr: {gradientTransform: "rotate(360, 0.5, 0.5)"}, repeat: -1, yoyo: false, ease: 'none'});

  ////////////////////////////// Elements Animation: Blobs
  let radius = 50; // 40;
  let attrFn = (i, deg) => {
    let r = i*90+deg;
    return { transform:'rotate('+r+') translate('+radius+',0.1) rotate('+(-r)+')' };
  }
  hocoElBlobTl = gsapRef.timeline({paused: true})
  .fromTo('.blob-g2 .blob-a',
    { attr: i => attrFn(i, 0) },
    { attr: i => attrFn(i, 360), duration: 10, ease: 'none', repeat: -1 })
  .fromTo('.blob-g2 .blob-a', 
    { morphSVG: (i, target) => `${hocoSel} .${target.id.substring(0, 6)}.blob-a`},
    { morphSVG: (i, target) => `${hocoSel} .${target.id.substring(0, 6)}.blob-b`, duration: 3, ease:'none', repeat:-1, yoyo: true }, 0);

  
  ////////////////////////////// Contact show
  hocoShowTl = gsapRef.timeline({
    scrollTrigger:{
      id: 'hocoShowTl',
      trigger: hocoSel,
      // start: 'top bottom',
      start: 'top 5%',
      end: '+=0',
      toggleActions: 'restart none reverse none',
      onEnter: (self) => {
        // console.log(`[home contact] hocoShowTl onEnter: appData.isResizing[${appData.isResizing}]`);

        document.querySelector('.page-home .sector.photo-retouching').classList.remove('cursor-draggable'); // retouching draggable set
        
        smootherRef.paused(true);
        hocoElsControl('play');
        gsapRef.set(`${hocoSel} .contents-wrapper`, {pointerEvents: 'all'}); // pointer-events retouching -> contact
      },
      // onLeave: (self) => {},
      onEnterBack: (self) => {
        smootherRef.paused(true);        
        gsapRef.set(`${hocoSel} .contact-infos`, {pointerEvents: 'none'}); // contact-info unclickable
      },
      // onLeaveBack: (self) => {},
    },
    // onStart: () => {},
    onComplete: () => {
      // console.log(`[home contact] hocoShowTl onComplete: appData.isResizing[${appData.isResizing}]`);

      document.querySelector('.page-home .sector.photo-retouching').classList.remove('cursor-draggable'); // retouching draggable set, Do it here once more for when resizing. hocoshowTl.onEnter called before horeRetouchOnTl.onComplete and it add .cursor-draggable again
      smootherRef.paused(false);      
      gsapRef.set(`${hocoSel} .contact-infos`, {pointerEvents: 'all'});// contact-info clickable
    },
    onReverseComplete: () => {
      document.querySelector('.page-home .sector.photo-retouching').classList.add('cursor-draggable'); // retouching draggable set
      
      smootherRef.paused(false);
      hocoElsControl('pause');
      gsapRef.set(`${hocoSel} .contents-wrapper`, {pointerEvents: 'none'}); // pointer-events contact -> retouching
    }
  })
  .to(`${hocoSel} .contents-bg`, {duration: 0.7, opacity: 1, ease: 'none'})

  .addLabel('t01', 0)
  .to(`${hocoSel} #blob01-g`, {duration: 0.3, opacity: 1, ease: 'power1.out'}, 't01')
  .to(`${hocoSel} #blob01-g`, {duration: 0.7, x: '0%', y: '0%', rotate: 0, scale: 1, ease: 'power1.out'}, 't01')
  .to(`${hocoSel} #blob01-a`, {duration: 0.7, morphSVG: `${hocoSel} #blob01-b`, ease: 'power3.in'}, `t01`)
  // .to(`${hocoSel} #blob01-a`, {duration: 0.35, morphSVG: `${hocoSel} #blob01-a`, ease: 'none'}, 't01')
  // .to(`${hocoSel} #blob01-a`, {duration: 0.35, morphSVG: `${hocoSel} #blob01-b`, ease: 'none'}, `t01+=${0.35}`)
      
  .addLabel('t02', 0.1)
  .to(`${hocoSel} #blob02-g`, {duration: 0.3, opacity: 1, ease: 'power1.out'}, 't02')
  .to(`${hocoSel} #blob02-g`, {duration: 0.5, x: '0%', y: '0%', rotate: 0, scale: 1, ease: 'power1.out'}, 't02')
  .to(`${hocoSel} #blob02-a`, {duration: 0.5, morphSVG: `${hocoSel} #blob02-b`, ease: 'power3.in'}, 't02')
  // .to(`${hocoSel} #blob02-a`, {duration: 0.25, morphSVG: `${hocoSel} #blob02-a`, ease: 'none'}, 't02')
  // .to(`${hocoSel} #blob02-a`, {duration: 0.25, morphSVG: `${hocoSel} #blob02-b`, ease: 'none'}, `t02+=${0.25}`)
      
  .addLabel('t03', 0.2)
  .to(`${hocoSel} #blob03-g`, {duration: 0.3, opacity: 1, ease: 'power1.out'}, 't03')
  .to(`${hocoSel} #blob03-g`, {duration: 0.5, x: '0%', y: '0%', rotate: 0, scale: 1, ease: 'power1.out'}, 't03')
  .to(`${hocoSel} #blob03-a`, {duration: 0.5, morphSVG: `${hocoSel} #blob03-b`, ease: 'power3.in'}, `t03`)
  // .to(`${hocoSel} #blob03-a`, {duration: 0.25, morphSVG: `${hocoSel} #blob03-a`, ease: 'none'}, 't03')
  // .to(`${hocoSel} #blob03-a`, {duration: 0.25, morphSVG: `${hocoSel} #blob03-b`, ease: 'none'}, `t03+=${0.25}`)
      
  .addLabel('t04', 0.35)
  .to(`${hocoSel} #blob04-g`, {duration: 0.3, opacity: 1, ease: 'power1.out'}, 't04')
  .to(`${hocoSel} #blob04-g`, {duration: 0.5, x: '0%', y: '0%', rotate: 0, scale: 1, ease: 'power1.out'}, 't04')
  .to(`${hocoSel} #blob04-a`, {duration: 0.5, morphSVG: `${hocoSel} #blob04-b`, ease: 'power3.in'}, `t04`)
  // .to(`${hocoSel} #blob04-a`, {duration: 0.25, morphSVG: `${hocoSel} #blob04-a`, ease: 'none'}, 't04')
  // .to(`${hocoSel} #blob04-a`, {duration: 0.25, morphSVG: `${hocoSel} #blob04-b`, ease: 'none'}, `t04+=${0.25}`)
      
  .addLabel('t05', 0.5)
  .to(`${hocoSel} #blob05-g`, {duration: 0.2, opacity: 1, ease: 'power1.in'}, 't05')
  .to(`${hocoSel} #blob05-g`, {duration: 0.5, x: '0%', y: '0%', rotate: 0, scale: 1, ease: 'power1.out'}, 't05')
  .to(`${hocoSel} #blob05-a`, {duration: 0.5, morphSVG: `${hocoSel} #blob05-b`, ease: 'power3.in'}, `t05`)
  // .to(`${hocoSel} #blob05-a`, {duration: 0.25, morphSVG: `${hocoSel} #blob05-a`, ease: 'none'}, 't05')
  // .to(`${hocoSel} #blob05-a`, {duration: 0.25, morphSVG: `${hocoSel} #blob05-b`, ease: 'none'}, `t05+=${0.25}`)  

  .addLabel('t06', '-=0.2')
  /////// jess: blob-g2-wrapper1 > blog-g2: postioned as in svg
  // .to(`${hocoSel} .blob-g2-wrapper1 #blob08-g`, {duration: 1, opacity: 1, x: '0%', y: '0%', rotate: 0, scale: 1, ease: 'power2.out'}, 't06')
  .to(`${hocoSel} .blob-g2-wrapper1 #blob08-g`, {duration: 0.2, opacity: 1, ease: 'power1.out'}, 't06')
  .to(`${hocoSel} .blob-g2-wrapper1 #blob08-g`, {duration: 1, x: '0%', y: '0%', rotate: 0, scale: 1, ease: 'back.out(1.4)'}, 't06')
  .to(`${hocoSel} .blob-g2-wrapper1 .blob-g2:not(#blob08-g)`, {duration: 1, opacity: 1, x: '0%', y: '0%', rotate: 0, scale: 1, ease: 'back.out(1.4)', stagger: 0.1}, 't06+=0.1')
  /////// jess: blob-g2-wrapper1 > blog-g2: added later & positioned as needed
  .to(`${hocoSel} .blob-g2-wrapper2 #blob06-g-add1`, {duration: 1, opacity: 1, x: '-20%', y: '30%', rotate: 0, scale: 1, ease: 'back.out(1.4)'}, 't06+=0.6')
  .to(`${hocoSel} .blob-g2-wrapper2 #blob07-g-add1`, {duration: 1, opacity: 1, x: '-20%', y: '-90%', rotate: 40, scale: 1.1, ease: 'back.out(1.4)'}, 't06+=0.55')
  .to(`${hocoSel} .blob-g2-wrapper2 #blob08-g-add1`, {duration: 1, opacity: 1, x: '-30%', y: '-50%', rotate: 0, scale: 0.4, ease: 'back.out(1.4)'}, 't06+=0.55')
  .to(`${hocoSel} .blob-g2-wrapper2 #blob09-g-add1`, {duration: 1, opacity: 1, x: '-50%', y: '-10%', rotate: 60, scale: -0.8, ease: 'back.out(1.4)'}, 't06+=0.45')
  .to(`${hocoSel} .blob-g2-wrapper2 #blob10-g-add1`, {duration: 1, opacity: 1, x: '20%', y: '-60%', rotate: 0, scale: 0.7, ease: 'back.out(1.4)'}, 't06+=0.25')

  .to(`${hocoSel} .drops`, {duration: 0.5, opacity: 1, ease: 'power1.in'}, '-=0.5')

  .addLabel('tContact', '-=0.8')
  .to(`${hocoSel} .components-behind`, {duration: 0.5 , opacity: 1, ease: 'none'}, `tContact+=${0}`)
  .to(hocoSel+'.contact.no1 .use2', { duration: 0.5, strokeDashoffset: hocoContactLen2, ease: 'power1.in' }, `tContact+=${0}`)
  .to(hocoSel+'.contact.no1 .use1', { duration: 0.5,  opacity: 1, ease: 'power2.in'}, `-=0.5`)
  .to(hocoSel+'.contact.no1 .use2', { duration: 0.1,  opacity: 0, ease: 'power2.in'}, `-=0.1`)
  .to(hocoSel+'.contact:not(.no1)', { duration: 0.3,  opacity: 1, ease: 'power1.out'}, `-=0.1`)
  .to(hocoSel+'.contact:not(.no1)', {duration: 0.7, y: (i) => ((5 - i) * -10) + '%', stagger: 0.05, ease: 'back.out(4)'}, `-=0.3`)
  
  .to(hocoSel+'.contact-info', {duration: 0.5, opacity: 1, y: '0%', rotateX: 0, stagger: 0.1, ease: 'power1.out'}, `tContact+=${1}`)
  ;
}


////////////////////////////////////////////////// Scroll: clear
const hocoScrollClear = () => {
  if(hocoScrubTl1) { hocoScrubTl1.revert(); hocoScrubTl1 = null; }
  if(hocoElGrTl) { hocoElGrTl.revert(); hocoElGrTl = null; }
  if(hocoElBlobTl) { hocoElBlobTl.revert(); hocoElBlobTl = null; }
  if(hocoShowTl) { hocoShowTl.revert(); hocoShowTl = null; }
}


////////////////////////////////////////////////// Code for snippet
// if(hocoIsSnippet) {
//   hocoInit(gsapRef, splitText);
//   hocoScrollMake(gsapRef, scrollTrigger, smoother, splitText);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Elements Animation Control
const hocoElsControl = (opt='play') => {
  if(opt === 'play') {
    hocoElGrTl.play();
    hocoElBlobTl.play();
    document.querySelector(`${hocoSel} .drops`).style.setProperty('--hoco-drop-play-state', 'running');

  } else {
    hocoElGrTl.pause();
    hocoElBlobTl.pause();
    document.querySelector(`${hocoSel} .drops`).style.setProperty('--hoco-drop-play-state', 'paused');
  }
}



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Resizing
const hocoResizeStart = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home contact] Resize: START");
}

const hocoResizeDone = (gsapRef, scrollTriggerRef, smootherRef, splitTextRef) => {
  console.log("[home contact] Resize: END");

  hocoScrollClear();
  hocoInit(gsapRef, splitTextRef);
  hocoScrollMake(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
}

////////// Code for snippet
// let hocoResizing = false;
// const hocoResizeHandle = (e) => {
//   if(!hocoResizing) {
//     hocoResizing = true;
//     smootherRef.paused(true);
//     scrollTriggerRef.disable();

//     hocoResizeStart(gsapRef, scrollTriggerRef, smootherRef, splitTextRef);
//   }

//   waitForFinalEvent(function() {
//     hocoResizing = false;
//     smootherRef.paused(false);
//     scrollTriggerRef.enable();
//     scrollTriggerRef.refresh(); // jess: After resizing done, refresh the ScrollTrigger

//     hocoResizeDone(gsapRef, scrollTriggerRef, smootherRef, splitTextRef, draggableRef);
//   }, 1000, 'hocoResize');
// }
// if(hocoIsSnippet) {
//   if(typeof hocoIsRevert !== 'undefined') window.removeEventListener('resize', hocoResizeHandleRef);
//   window.hocoResizeHandleRef = hocoResizeHandle;
//   window.addEventListener('resize', hocoResizeHandleRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Control Key
////////////////////////////////////////////////// Play / Pause Elements animation
const hocoControlKey = (key) => {
  if(!document.querySelector(".page-home") || !hocoElBlobTl) return;

  let opt = hocoElBlobTl.paused() ? 'play' : 'pause';
  hocoElsControl(opt);
  console.log(`[home: control] [key: ${key} pressed] Elements animation: ${opt}`);
};

////////////////////////////////////////////////// Code for snippet
// const hocoControlKeyHandler = (e) => { if(e.key === '7') hocoControlKey(e.key); }
// if(hocoIsSnippet) {
//  if(typeof hocoIsRevert !== 'undefined') window.removeEventListener('keydown', hocoControlKeyHandlerRef);
//   window.hocoControlKeyHandlerRef = hocoControlKeyHandler;
//   window.addEventListener('keydown', hocoControlKeyHandlerRef);
// }



////////////////////////////////////////////////////////////////////////////////////////////////////
/// Code for snippet
// if(hocoIsSnippet) var hocoIsRevert = true;



//////////////////////////////////////////////////////////////////////////////////////////////////
/// Export
export {
  hocoInit,
  hocoScrollMake,
  hocoScrollClear,
  hocoElsControl,
  hocoResizeStart,
  hocoResizeDone,
  hocoControlKey
}